/* ==========================================================================
   IRON CREST LEATHER — faq.js
   Topic filter, search and single-open behaviour for the help centre.

   The answers are native <details> in the markup, so with no script at all
   every question is readable, linkable, printable and searchable by the
   browser's own find. Both controls this file drives ship with the `hidden`
   attribute and are revealed below: a filter nothing can act on is worse than
   no filter at all.

   Shopify: assets/faq.js. The groups become blocks on sections/main-faq.liquid
   and data-cat becomes block.settings.topic.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var body = document.querySelector('[data-faq-body]');
    if (!body) return;
    if (body.icBooted) return;   // already live; the editor replaced a different section
    body.icBooted = true;

    var nav = document.querySelector('[data-faq-nav]');
    var form = document.querySelector('[data-faq-search]');
    var input = form && form.querySelector('input');
    var clear = document.querySelector('[data-faq-clear]');
    var empty = document.querySelector('[data-faq-empty]');

    var groups = Array.prototype.slice.call(body.querySelectorAll('.fgroup'));
    var items = Array.prototype.slice.call(body.querySelectorAll('[data-q]'));
    if (!items.length) return;

    // cache the searchable text once — reading it per keystroke would mean
    // touching the DOM 26 times for every character typed
    var hay = items.map(function (el) {
      return (el.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    });

    /* ------------------------------------------------------ reveal controls */
    if (nav) nav.hidden = false;
    if (form) form.hidden = false;

    // the count is a script-only affordance, so the script creates it
    var count = null;
    if (form) {
      count = document.createElement('p');
      count.className = 'fcount';
      count.setAttribute('role', 'status');
      count.hidden = true;
      form.parentNode.insertBefore(count, form.nextSibling);
    }

    /* ------------------------------------------------------- single at once */
    // …except while a search is running. apply() opens every match, and without
    // this guard the handler below would immediately shut all but the last one,
    // leaving a result list whose answers are hidden — the opposite of the point.
    items.forEach(function (el) {
      el.addEventListener('toggle', function () {
        if (!el.open || searching) return;
        items.forEach(function (other) { if (other !== el) other.open = false; });
      });
    });

    /* --------------------------------------------------------------- filter */
    var topic = 'all';
    var query = '';
    var searching = false;

    function apply() {
      var q = query.trim().toLowerCase();
      searching = q.length > 1;
      var shown = 0;

      items.forEach(function (el, i) {
        var group = el.closest('.fgroup');
        var inTopic = topic === 'all' || (group && group.getAttribute('data-cat') === topic);
        var hit = !searching || hay[i].indexOf(q) !== -1;
        var visible = inTopic && hit;
        el.hidden = !visible;
        // a match the reader cannot see the answer to is not a match
        if (searching && visible) el.open = true;
        else if (searching) el.open = false;
        if (visible) shown++;
      });

      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-q]:not([hidden])');
      });

      body.setAttribute('data-searching', searching ? 'true' : 'false');
      if (empty) empty.hidden = shown !== 0;

      if (count) {
        count.hidden = !searching;
        count.textContent = shown === 1
          ? '1 answer matches “' + query.trim() + '”'
          : shown + ' answers match “' + query.trim() + '”';
      }
      if (clear) clear.hidden = !query;
    }

    /* ------------------------------------------------------------ the nav */
    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cat]');
        if (!btn) return;
        topic = btn.getAttribute('data-cat');
        Array.prototype.forEach.call(nav.querySelectorAll('[data-cat]'), function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
        // clear the search when a topic is chosen: the two filters combined
        // produce empty results far more often than they produce useful ones
        query = '';
        if (input) input.value = '';
        apply();
        var first = body.querySelector('.fgroup:not([hidden])');
        if (first) first.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }

    /* --------------------------------------------------------- the search */
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    }
    if (input) {
      var debounce;
      input.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          query = input.value;
          // a search is a search of everything, not of the open topic
          if (query.trim().length > 1 && topic !== 'all') {
            topic = 'all';
            if (nav) {
              Array.prototype.forEach.call(nav.querySelectorAll('[data-cat]'), function (b) {
                b.setAttribute('aria-current', b.getAttribute('data-cat') === 'all' ? 'true' : 'false');
              });
            }
          }
          apply();
        }, 140);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) { input.value = ''; query = ''; apply(); }
      });
    }
    if (clear) {
      clear.addEventListener('click', function () {
        query = '';
        if (input) { input.value = ''; input.focus(); }
        apply();
      });
    }

    apply();
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
